import { render } from "./RegionObj.vue?vue&type=template&id=15a4c4a3"
import script from "./RegionObj.vue?vue&type=script&lang=js"
export * from "./RegionObj.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__